import * as _ from "lodash";
import http from "../constant/api-widget";

export const SessionWidgetService = {
  addSessionWidget: async (data) => {
    const result = await http.post(`/api/session-widget/add`, data, {
      domain: _.get(data, "domain"),
    });

    return result;
  },
  editSessionWidget: async (id, data) => {
    const result = await http.put(`/api/session-widget/${id}/edit`, data, {
      domain: _.get(data, "domain"),
    });

    return result;
  },
  readSessionWidget: async (id, domain) => {
    const result = await http.get(`/api/session-widget/${id}/read`, { domain });

    return result;
  },
};
